import { render, staticRenderFns } from "./TrxR_Search.vue?vue&type=template&id=67e64868"
import script from "./TrxR_Search.vue?vue&type=script&lang=js"
export * from "./TrxR_Search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports